/**
 * Hide superseded CareCommunication imports from inbox and threads.
 * Rows stay in Communicate and in clinic_medcom_message_archives for audit.
 */

export function archivedMessageIdSet(ids: readonly string[]): Set<string> {
  const set = new Set<string>();
  for (const id of ids) {
    if (id.length > 0) set.add(id);
  }
  return set;
}

export function withoutArchivedMessages<T extends { id: string }>(
  items: readonly T[],
  archivedIds: ReadonlySet<string>,
): T[] {
  if (archivedIds.size === 0) return [...items];
  return items.filter((item) => !archivedIds.has(item.id));
}

export function withoutArchivedSegments<
  T extends { messageId?: string; messageHeaderId?: string },
>(
  segments: readonly T[],
  archivedMessages: readonly { id: string; messageHeaderId?: string | null }[],
): T[] {
  if (archivedMessages.length === 0) return [...segments];
  const ids = new Set<string>();
  const headers = new Set<string>();
  for (const message of archivedMessages) {
    ids.add(message.id);
    if (message.messageHeaderId) headers.add(message.messageHeaderId);
  }
  return segments.filter((segment) => {
    if (segment.messageId && ids.has(segment.messageId)) return false;
    if (segment.messageHeaderId && headers.has(segment.messageHeaderId)) {
      return false;
    }
    return true;
  });
}

export function isMissingArchiveTable(code: string | undefined): boolean {
  return code === '42P01' || code === 'PGRST205';
}
